import "./Header.css";
import { FaBriefcase, FaLightbulb, FaChartLine, FaUsers, FaBullhorn, FaPaintBrush, FaCode, FaBuilding, FaUniversity, FaUserGraduate, FaCompass, FaPassport, FaBook } from "react-icons/fa";
import { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Reviews from "./Review";
import WhyChooseUs from "./whychooseus";
import HowWeWork from "./Howitworks";
import { FaWhatsapp } from "react-icons/fa";
import image1 from '../Pages/images/bridge.jpg'
import image2 from '../Pages/images/can.jpeg'
import image3 from '../Pages/images/aus.jpg'
import { Link } from "react-router-dom";
import CoachingSection from "./Course";
import CountriesSection from "./Contryselection";
import CountryGrid from "./country";
import ChatBot from "./Chatbot";
const whatsappNumber = "9618001019";
gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  const [students, setStudents] = useState(0);
  const [universities, setUniversities] = useState(0);
  const headerRef = useRef(null);
  const servicesRef = useRef(null);
  const coursesRef = useRef(null);
  
  useEffect(() => {
    
    gsap.fromTo(
      servicesRef.current.children,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: "power2.out", scrollTrigger: { trigger: servicesRef.current, start: "top 80%" } }
    );

  

    // gsap.fromTo(
    //   statsRef.current.children,
    //   { opacity: 0, y: 50 },
    //   { opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: "power2.out", scrollTrigger: { trigger: statsRef.current, start: "top 50%" } }
    // );

    gsap.to({}, { duration: 3, onUpdate: () => setStudents((prev) => (prev < 50 ? prev + 1 : 50)) });
    gsap.to({}, { duration: 3, onUpdate: () => setUniversities((prev) => (prev < 50 ? prev + 1 : 50)) });
  }, []);
  // useEffect(() => {
  //   ScrollTrigger.create({
  //     trigger: statsRef.current,
  //     start: "top 80%",
  //     onEnter: () => {
  //       gsap.to({}, {
  //         duration: 2.5,
  //         onUpdate: function () {
  //           const progress = this.progress();
  //           setStudents(Math.floor(progress * 50));
  //           setUniversities(Math.floor(progress * 50));
  //         },
  //       });
  //     },
  //     onLeaveBack: () => {
  //       setStudents(0);
  //       setUniversities(0);
  //     }
  //   });
  // }, []);
  const images = [
    image1,
    image2,
    image3
  ];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <header className="header">
      <img
        src={images[index]}
        alt="Background"
        className="background-image"
      />
      <div className="header-content">
        <h1>WELLCOME TO CLYRA OVERSEAS</h1>
        <Link to="/contactus" className="cta-button">contact us</Link>
      </div>
    </header>
      
<section className="services-section" ref={servicesRef}>
  <div className="services-header">
    <h2>Our Services</h2>
    <p>We provide comprehensive support to help you achieve your international education and career goals, from selecting the right university to securing your visa.</p>
  </div>

  <div className="services-container">
    {[
      { icon: <FaUniversity />, title: "University Selection", text: "Guiding you to choose the best university for your future." },
      { icon: <FaUserGraduate />, title: "Admission Guidance", text: "Helping you navigate the admission process with ease." },
      { icon: <FaCompass />, title: "Career Guidance", text: "Providing expert advice to shape your career path." },
      { icon: <FaPassport />, title: "Visa Preparation", text: "Assisting you in hassle-free visa processing." }
    ].map((service, index) => (
      <div className="service-box" key={index}>
        <div className="service-icon">{service.icon}</div>
        <h3>{service.title}</h3>
        <p>{service.text}</p>
      </div>
    ))}
  </div>
</section>

<ChatBot/>

<CountryGrid/>

      <a
      href={`https://wa.me/${whatsappNumber}`}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
        <CoachingSection/>
    
      
      {/* <section className="statistics" ref={statsRef}>
        <div className="stat-box">
          <h3>{students}+</h3>
          <p>Students Enrolled</p>
        </div>
        <div className="stat-box">
          <h3>{universities}+</h3>
          <p>Partner Universities</p>
        </div>
      </section> */}
      <section>
        <HowWeWork/>
      </section>
      <section>
        <WhyChooseUs />
      </section>
    
      <section>
        <Reviews />
      </section>
    </>
  );
};

export default Header;